export class Tags {
    private static readonly maxColumns: number = 3;
    private static readonly maxColumnWidth: number = 420;
    private static readonly delay: number = 150;

    public removePostsIfThereAreTags(): void {
        const tags = document.querySelector('.tags');
        const posts = document.querySelector('.posts');

        if (!posts) {
            return;
        }

        if (tags) {
            posts.remove();
        }
    }

    public initAosDelays(): void {
        const tags = document.querySelectorAll<HTMLElement>('.tag');
        const columns = this.getColumns();

        for (const [ i, tag ] of tags.entries()) {
            const delay = (i % columns) * Tags.delay;

            tag.dataset.aosDelay = delay.toString(10);
        }
    }

    private getColumns(): number {
        for (let i = Tags.maxColumns; i >= 2; i--) {
            if (window.innerWidth > Tags.maxColumnWidth * (i - 1)) {
                return i;
            }
        }

        return 1;
    }
}
